import { SVGProps } from 'react';

const BellScaleMediumCrossedFalse = (props: SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M14 21C13.7968 21.3042 13.505 21.5566 13.154 21.7321C12.803 21.9076 12.4051 22 12 22C11.5949 22 11.197 21.9076 10.846 21.7321C10.495 21.5566 10.2032 21.3042 10 21M4 17V14C4 14 6.20442 12.9339 6.28854 10.8747V6.78769C6.38334 4.45359 8.8 2.00302 11.4667 2.0013C14.1333 1.99958 9.86667 1.99957 12.5389 2.00126C15.2111 2.00296 17.6166 4.45359 17.7115 6.78769V10.8747C17.7955 12.9339 20 14 20 14V17H4Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default BellScaleMediumCrossedFalse;
